import * as React from 'react';
import { useDispatch } from 'react-redux';
import { PageBody } from '../../../../components/page-components/PageBody';
import { PageContent } from '../../../../components/page-components/PageContent';
import { PagedList } from '../../../../components/paged-list/PagedList';
import { PagedApiResult } from '../../../../models/utilities/paged-request';
import { StatusCode } from '../../../../utils/api';
import { PageNames } from '../../../../utils/app-constants';
import { SupportActivityRow } from '../components/SupportActivityRow';
import { SearchEventSummary } from '../../../../support/models/activity/search-event-summary';
import { SupportActivitySearchFilters } from '../../../../support/models/support-activity-search-filters';
import { SupportSvc } from '../../../../support/service';
import '../../../../support/styles.scss';

export const ActivityScene = () => {

    const dispatch = useDispatch();
    const [service] = React.useState(new SupportSvc());
    const [filterParams, setFilterParams] = React.useState(new SupportActivitySearchFilters());

    const [messages, setMessages] = React.useState(() => {
         const initial = new PagedApiResult<SearchEventSummary>();
         initial.pagination = filterParams.paginationInfo;
         initial.pagination.reusePaging = true;
         return initial;
    });

    /**
     * OnSearch handler
     * @param filters The user search filters to apply
     */
    const onSearch = async (filters: SupportActivitySearchFilters) => {
        const response = await service.search(SearchEventSummary, filters);
        if (response.status === StatusCode.Success) {
            setMessages(response.data);
            scrollTo();
        }

        setFilterParams(filters);
    };

    const onParamsUpdate = (itm : any) => {
        setFilterParams(itm);
    };

    const onParamsReset = () => {
        const tmp = new SupportActivitySearchFilters();
        setFilterParams(tmp);
    };
    
    return <PageContent pageName={PageNames.SUPPORT_ACTIVITY_FEED}>
            <PageBody>
                <PagedList
                    noResultsMessage="No events found, please search again."
                    searchCallback={ onSearch }
                    data={ messages }
                    filterProps={ filterParams }
                    selectableClass=""
                    onFilterUpdate={ onParamsUpdate }
                    onReset={ onParamsReset }
                    rowRenderer={(itm: SearchEventSummary) => 
                        <SupportActivityRow
                            key={itm.id}
                            event={itm}
                        />                    
                    }
                />                   
            </PageBody>
        </PageContent>;
};
